// File: src/components/pages/admin/AdminDashboard.jsx

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LayoutDashboard } from 'lucide-react';
import { AUTH0_NAMESPACE } from '../../../utils/constants';
import '../../../styles/unified.css';

const AdminDashboard = () => {
  const { user } = useAuth0();
  const adminName = user?.[`${AUTH0_NAMESPACE}/name`] || user?.name || 'Admin';

  return (
    <div className="page-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-left">
          <LayoutDashboard size={32} className="page-icon" />
          <div>
            <h1 className="page-title">Admin Dashboard</h1>
            <p className="page-description">Welcome back, {adminName}</p>
          </div>
        </div>
      </div>

      {/* Placeholder body — content goes here */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        background: '#f9fafb',
        borderRadius: '0.75rem',
        border: '2px dashed #e5e7eb',
        color: '#9ca3af',
        flexDirection: 'column',
        gap: '0.75rem'
      }}>
        <LayoutDashboard size={48} strokeWidth={1.5} />
        <p style={{ fontSize: '1.1rem', fontWeight: 500 }}>Admin Dashboard — coming soon</p>
      </div>
    </div>
  );
};

export default AdminDashboard;
